import { CookieCollection, getUrlParameter, showLoader } from './script';
import * as log from 'loglevel';
import * as _ from 'lodash';
import * as Api from './api';

export const ResultPage = (() => {
  async function init() {
    showLoader();
    const url = window.location.href;
    const sessionId = getUrlParameter('sessionId') ?? '';
    const supplierUrl = extractPathParameter(url) ?? '';

    const bookingDetails = CookieCollection.BookingDetails.get();
    if (!bookingDetails) {
      log.error('bookingDetails should not be undefined');
      return;
    }
    
    const isGiftPurchase = (CookieCollection.PersonBooking.get()?.giftValue && CookieCollection.PersonBooking.get()?.giftValue != 0) === true;
    
    try {
      var response = await Api.validateWindcaveSession(sessionId, supplierUrl);
      if (response.data.success){
        if (!isGiftPurchase)
        {
          clearCookies();
          const successUrl = String($('#successUrl').val());
          window.location.replace(`${successUrl}?confirmation_id=${bookingDetails.id}&summarycode=1&sessionId=${sessionId}`);
        } else {
          window.location.replace(`./success?confirmation_id=${bookingDetails.id}&summarycode=1&sessionId=${sessionId}`);
        }
      } else {
        redirectOnFailedPayment(isGiftPurchase);
      }
    }
    catch {
      redirectOnFailedPayment(isGiftPurchase);
    }
  }


  
  return {
    init: init
  };
})();

const clearCookies = () => {
  CookieCollection.BookingDetails.remove();
  CookieCollection.Addons.remove();
  CookieCollection.Dates.remove();
  CookieCollection.DatesDisplay.remove();
  CookieCollection.FlexibleDates.remove();
  CookieCollection.GiftVoucher.remove();
  CookieCollection.PaymentState.remove();
  CookieCollection.PersonBooking.remove();
  CookieCollection.PriceDisplay.remove();
  CookieCollection.ProductSearch.remove();
  CookieCollection.PromoCode.remove();
  CookieCollection.SelectedRooms.remove();
}

const extractPathParameter = (url: string) => {
  const urlObj = new URL(url);
  const pathname = urlObj.pathname;
  const pathSegments = pathname.split('/');

  if (pathSegments.length >= 2) {
    return pathSegments[pathSegments.length - 2];
  } else {
    return null;
  }
}

const redirectOnFailedPayment = (isGiftPurchase: boolean) => {
  const errorMessage = 'Failed to process payment';
  if (isGiftPurchase)
  {
    window.location.replace(`./process-gift?error=${errorMessage}`);
  } else{
    window.location.replace(`./process-payment?error=${errorMessage}`);
  }
}


// Success gift voucher page scripts:
export const SuccessPage = (() => {
  const bookingRowTemplate = _.template(
    '<div class="bookingrow"><p class="roomtitle"><strong>Room <%= room %><br/></strong><span class="adults">Adults: <%= adultCount %></span><%= childHtml %><%= addonsHtml %></p></div>'
  );

  const testMode = false;

  function showResult() {
    const personBooking = CookieCollection.PersonBooking.get();
    const bookingDetails = CookieCollection.BookingDetails.get();

    if (!personBooking) {
      log.error('personBooking should not be undefined');
      return;
    }

    if (!bookingDetails) {
      log.error('bookingDetails should not be undefined');
      return;
    }

    $('#purchaserEmail').text(personBooking.emailAddress);
    $('#bookingID').text(bookingDetails.id);
    $('#purchaserName').text(personBooking.firstName);
    $('#recipientName').text(personBooking.giftFirstName + ' ' + personBooking.giftLastName);
    $('#recipientEmail').text(personBooking.giftEmailAddress);
    $('#giftMessage').text(personBooking.giftMessage);
    if (personBooking.giftValue == -1)
    {
      $('#totalprice').text('$' + personBooking.customValue);
    }
    else
    {
      $('#totalprice').text('$' + personBooking.giftValue);
    }

    clearCookies();
    
    let html = '<div>';
    let total = 0;

    html += '</div>';
    $('#yourgroup').html(html);
    

    $('.confirmpanel').show();
    $('.loader').hide();
  }

  function showError() {
    $('.main-container').append(
      '<div><h2 class="text-align-center">Unexpected error: Please contact customer support.</h2></div>'
    );
    $('.loader').hide();
  }

 
  function init() {
      showResult();
  }

  return {
    init: init
  };
})();

// TODO: Move script call to actual page?
$(() => {
  if ($('body.taronga-sydney').length > 0) {
    SuccessPage.init();
  }
});
